<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <img class="logo-icon" src="assets/images/logos/arvore 24x24 px-01.png">
        <span class="logo-text secondary-text">Prosperidade Investimentos</span>
    </div>

    <div class="buttons">

        <button 
            mat-icon-button 
            class="toggle-sidebar-folded"
            (click)="toggleSidebarFolded()" 
            fxHide.lt-lg
        >
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button 
            mat-icon-button 
            class="toggle-sidebar-opened"
            (click)="toggleSidebarOpened()" 
            fxHide.gt-md
        >
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground"
     fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div 
        class="user" 
        fxLayout="column" 
        [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
        *ngIf='user' 
    >
        <div class="h3 username">{{user.name}}</div>
        <div class="h5 email hint-text mt-8" *ngIf=" user.codigo_aai != '' ">Cód. Assessor: {{user.codigo_aai}}</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="{{user.url_avatar}}">
        </div>

    </div><br/>


    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>
